import { createCustomEnum } from "./customEnum";

const BusinessUnitTypes = createCustomEnum({
	Aurora: { value: 1, name: "aurora", displayName: "Aurora" },
	BusinessDevelopment: {
		value: 2,
		name: "business_development",
		displayName: "Business Development",
	},
	Acquisition: { value: 3, name: "acquisition", displayName: "Acquisition" },
	OnePayment: { value: 4, name: "one_payment", displayName: "One Payment" },
	VnSystems: { value: 5, name: "vn_systems", displayName: "VN Systems" },
});

export default BusinessUnitTypes;
